<template>
	<div>
		<span class="goods-company-summary-excel" @click="excelExport"></span>
		<tips-select v-model="contentShow" :tipsFont="contentFont" :btnFont="contentBtnFont" @tipStatus="onContentSelect"></tips-select>
		<tips-select v-model="styleShow" :tipsFont="styleFont" :btnFont="styleBtnFont" @tipStatus="onStyleSelect"></tips-select>
	</div>
</template>
<style>

</style>
<script>
	import TipsSelect from '../components/TipsSelect'

	export default {
		components: {
			TipsSelect
		},
		name: 'ExcelExport',
		data () {
			return {
				contentType: null,
				styleType: null,
				contentShow: false,
				contentFont: '请选择导出数据的内容',
				contentBtnFont: ['导出金额', '导出数量', '导出金额和数量', '导出数量（订货）'],
				styleShow: false,
				styleFont: '请选择导出Excel的样式',
				styleBtnFont: ['以品项为列进行汇总', '以门店为列进行汇总']
			}
		},
		methods: {
			excelExport () {
				this.contentType = null
				this.styleType = null
				this.contentShow = true
			},
			onContentSelect (contentType) {
				this.contentType = contentType
				this.styleShow = true
			},
			onStyleSelect (styleType) {
				this.styleType = styleType
				this.$emit('excelExport', {content: this.contentType, style: this.styleType})
				this.contentType = null
				this.styleType = null
			}
		}
	}

</script>



// WEBPACK FOOTER //
// ExcelExport.vue?a5339376